import React, { useContext } from "react";
import { Header, Footer } from "../../Components";
import { Outlet } from "react-router-dom";
import { UserContext } from "../../Context";
import { Navigate } from "react-router-dom";
import { LOGIN } from "../../routes";

const Layout = ({ children }) => {
  const { user } = useContext(UserContext);
  const location = window.location.pathname;
  const isLoggedIn = Boolean(user);

  if (!isLoggedIn && location !== LOGIN) {
    return <Navigate to={LOGIN} replace />;
  }
  return (
    <>
      <div className="flex flex-col min-h-screen max-w-[100vw]">
        <Header />
        <main className="overflow-auto" style={{ height: "calc(100vh - 4rem)" }}>
          <Outlet />
        </main>
        <Footer />
      </div>

    </>
  );
};

export default Layout;
